import { useEffect, useState } from 'react';
import { useFireTrackingEvent } from '../../../../hooks/tracking/useTrackingEvents';

const useTrackSorting = (sorting: Sorting) => {
  const [prevSorting, setPrevSorting] = useState(sorting);
  const track = useFireTrackingEvent();

  useEffect(() => {
    if (sorting && sorting !== prevSorting) {
      track({
        event: 'product_list_sort',
        value: sorting,
      });
    }

    setPrevSorting(sorting);
  }, [sorting, prevSorting]);
};

export default useTrackSorting;
